module.exports = __webpack_public_path__ + "static/media/PDF.f236068e.svg";